module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/tipo-impresion/tipo-impresion.component.html
// module id = ./src/app/productos/tipo-impresion/tipo-impresion.component.html
// module chunks = main